const enNumberFormats = {
  currency: {
    style: 'currency',
    currency: 'USD'
  },
  currencyNoDecimal: {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }
};

const numberFormats = {
  'en': enNumberFormats,
  'en-US': enNumberFormats,
  'ja-JP': {
    currency: {
      style: 'currency',
      currency: 'JPY',
      currencyDisplay: 'symbol'
    },
    currencyNoDecimal: {
      style: 'currency',
      currency: 'JPY',
      currencyDisplay: 'symbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }
  }
}

export default numberFormats;
